import { useCallback } from 'react';

import { Breadcrumb } from 'components/Breadcrumb';
import { PageHeader } from '../../../components/PageHeader';
import { PageHeading } from 'components/PageHeading';
import { ListPage } from 'components/page-templates/ListPage';
import { Pagination } from '../../../components/pagination/Pagination';
import { Table, type ITableHeader } from 'components/table/Table';
import { IPaginationVariables, usePagination } from '../../../hooks/usePagination';
import { getTrackingLogs } from '../models';

const PAGE_SIZE = 50;

const TABLE_HEADERS: ITableHeader[] = [
  {
    id: 'id',
    name: 'ID',
  },
  {
    id: 'longitude',
    name: 'Longitude',
  },
  {
    id: 'latitude',
    name: 'Latitude',
  },
  {
    id: 'accuracy',
    name: 'Accuracy',
  },
  {
    id: 'altitude',
    name: 'Altitude',
  },
  {
    id: 'heading',
    name: 'Heading',
  },
  {
    id: 'speed',
    name: 'Speed',
  },
  {
    id: 'user',
    name: 'User',
  },
  {
    id: 'createdAt',
    name: 'Aangemaakt op',
  },
];

export const TrackingLogsPage = () => {
  const pageFetcher = useCallback(async (variables: IPaginationVariables) => {
    const res = await getTrackingLogs(variables.cursor, variables.take);
    return res.entries;
  }, []);
  const page = usePagination({
    key: 'id',
    pageSize: PAGE_SIZE,
    initialCursor: undefined,
    fetcher: pageFetcher,
  });

  return (
    <>
      <PageHeader title="Tracking Logs" />

      <ListPage
        heading={<PageHeading noMarginBottom leftSide={<Breadcrumb currentItem="Tracking Logs" />} />}
        pagination={
          <Pagination
            hasPrevious={page.hasPrevious}
            previous={page.previous}
            hasNext={page.hasNext}
            next={page.next}
            isFetching={page.isFetching}
          />
        }
      >
        <Table
          className="h-full"
          idKey="id"
          headers={TABLE_HEADERS}
          data={page.data}
          error={page.error}
          onRetry={page.retry}
          isLoading={page.isFetching}
          emptyState={<span className="text-sm text-fg-muted">Geen tracking logs gevonden</span>}
          mapData={(trackingLog) => {
            return [
              trackingLog.id,
              trackingLog.longitude.toFixed(2),
              trackingLog.latitude.toFixed(2),
              trackingLog.accuracy?.toFixed(2) ?? 'N/A',
              trackingLog.altitude?.toFixed(2) ?? 'N/A',
              trackingLog.heading?.toFixed(2) ?? 'N/A',
              trackingLog.speed?.toFixed(2) ?? 'N/A',
              trackingLog.user ? trackingLog.user.name : 'N/A',
              new Date(trackingLog.createdAt).toLocaleString(),
            ];
          }}
        />
      </ListPage>
    </>
  );
};
